import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AppversionNotifyModel = ({ show, handleClose, handleChange, handleSave, notificationData, editingNotification }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{editingNotification ? 'Edit Notification' : 'Add New Notification'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formDeviceType">
            <Form.Label>Device Type</Form.Label>
            <Form.Control
              as="select"
              name="deviceType"
              value={notificationData.deviceType}
              onChange={handleChange}
              placeholder="Enter description"
            >
              <option value="">Select Device Type</option>
              <option value="android">Android</option>
              <option value="ios">iOS</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formUrl">
            <Form.Label>URL</Form.Label>
            <Form.Control
              type="text"
              name="url"
              value={notificationData.url}
              onChange={handleChange}
              placeholder="Enter URL"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {editingNotification ? 'Update Notification' : 'Push Notification'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppversionNotifyModel;
